import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import { FortuneWheelSectionItem } from "../../../type/FortuneWheel";
import "./styles.sass";

type Props = {
  item: FortuneWheelSectionItem;
  popup?: boolean;
};

const RewardsItem: React.FC<Props> = ({ item, popup }) => {
  const { label, description, iconUrl } = item;
  const classReward = classNames("RewardsItem", {
    popup,
  });
  const t = useTranslate();

  return (
    <div className={classReward}>
      <div className="RewardsItem__text">
        <div className="RewardsItem__title">{t(label)}</div>
        <div className="RewardsItem__subtitle">{t(description)}</div>
      </div>
      <div className="RewardsItem__image">
        <img src={iconUrl} alt={t(label)} />
      </div>
    </div>
  );
};

export default RewardsItem;
